// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'
import {ProgressBar} from "../../progress_bar/ProgressBar";
import {JobStatus} from "../../../../interfaces/JobStatus";

@Component({
    components: {
        ProgressBar
    },
    mixins: [
        template,
    ]
})
export class JobStatusProgressBar extends Vue {

    @Prop()
    public status!: JobStatus

    get maxProgress() {
        if (this.status && this.status.job_status && this.status.job_status.progress && this.status.job_status.progress.max) {
            return this.status.job_status.progress.max
        } else {
            return 100;
        }
    }

    get minProgress() {
        if (this.status && this.status.job_status && this.status.job_status.progress && this.status.job_status.progress.min) {
            return this.status.job_status.progress.min
        } else {
            return 0;
        }
    }

    get currentProgress() {
        if (this.status && this.status.job_status && this.status.job_status.progress && this.status.job_status.progress.current) {
            return this.status.job_status.progress.current
        } else {
            return 0;
        }
    }

    get currentProgressNormalized() {
        let max = this.maxProgress
        let min = this.minProgress
        let current = this.currentProgress

        // Normalize to interval [0, 1]
        let normalized = (current - min) / (max - min);

        // Scale to interval [0, 100]
        return Math.round(100 * normalized);
    }

    get progressBarColorClass() {
        if (this.status.queue_status == 'waiting') {
            return 'mgs-progress-bar-color-grey';
        } else if (this.status.queue_status == 'failed') {
            return 'mgs-progress-bar-color-red';
        } else {
            return '';
        }
    }

    get queueStatusText() {
        switch (this.status.queue_status) {
            case 'waiting': return this.$t('JOB_QUEUE_STATUS_WAITING');
            case 'running': return this.$t('JOB_QUEUE_STATUS_RUNNING');
            case 'finished': return this.$t('JOB_QUEUE_STATUS_FINISHED');
            case 'failed': return this.$t('JOB_QUEUE_STATUS_FAILED');
            default: return ''
        }
    }
}